export default __webpack_public_path__ + "static/media/JYULogo.fd67ff06.svg";